import { DEFAULT_CONFIG } from '../config';

/**
 * ConfigService class helper class for loading configuration variables. All
 * variables are defined in getDefaultConfig and should be built from injected
 * variables from index.html's window.Config object
 * Any code that needs to access these properties should do so through this class.
 */
class ConfigService {

  constructor (configPromise) {
    this.configPromise = configPromise;
  }

  /**
   * Gets the default config json object.
   * Use specific getter for the property you need rather than getting the full config if possible.
   *
   * @return {Promise<object>} The config object promise
   */
  getConfig () {
    var self = this;
    return self.configPromise;
    // return self.configPromise.then((config) => {
      // let domain = window.location.hostname.replace(/[^.]+\./, '');
      // if (!config.keycloakUrl.includes(domain) && config.keycloakUrl.match(/(https?:\/\/[^.]+\.)(.*?)(\/.*)/)) {
      //   config.keycloakUrl = config.keycloakUrl.replace (/(https?:\/\/[^.]+\.)(.*?)(\/.*)/, '$1' + domain + '$3');
      // }
      // return config;
    // }) ;
  }

  /**
   * Gets the Auth Service config value.
   *
   * @return {Promise<string>} The auth service base url
   **/
  getAuthService() {
    var self = this;
    return self.configPromise.then(function(config) {
      return config.authService;
    });
  }

    /**
     * Gets the assurance apps service config value
     *
     * @return {Promise<string>} The apps service base url
     */
  getAdminService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.adminService;
    });
  }

  /**
   * Gets the assurance apps service config value
   *
   * @return {Promise<string>} The apps service base url
   */
  getAssuranceAppsService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.assuranceAppsService;
    });
  }

  /**
   * Gets the assurance query service config value
   *
   * @return {Promise<string>} The query service base url
   */
  getAssuranceQueryService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.assuranceQueryService;
    });
  }

  getAssuranceMdmService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.assuranceMdmService;
    });
  }

  getAssuranceAdrService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.assuranceAdrService;
    });
  }

  /**
   * Gets the assurance query service config value
   *
   * @return {Promise<string>} The query service base url
   */
  getAssuranceAlertConfigService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.assuranceAlertConfigService;
    });
  }

  /**
   * Gets the assurance preference service config value
   *
   * @return {Promise<string>} The preference service base url
   */
  getAssurancePreferenceService () { // TODO: This url is no longer assurance specific. Might want to change name.
    var self = this;
    return self.configPromise.then(function(config) {
        return config.assurancePreferenceService;
    });
  }

  /**
   * Gets the dashboard service config value
   *
   * @return {Promise<string>} The dashboard service base url
   */
  getDashboardService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.dashboardService;
    });
  }

  /**
   * Gets the keycloak url config value
   *
   * @return {Promise<string>} The keycloak base url
   */
  getKeycloakUrl () {
    var self = this;
    return self.configPromise.then(function(config) {
      // let domain = window.location.hostname.replace(/[^.]+\./, '');
      // if (domain === 'hppipeline.com') {
      //   domain = 'qa.wxpcollaboration.hp.com';
      // }
      // if (!config.keycloakUrl.includes(domain) && config.keycloakUrl.match(/(https?:\/\/[^.]+\.)(.*?)(\/.*)/)) {
      //   config.keycloakUrl = config.keycloakUrl.replace (/(https?:\/\/[^.]+\.)(.*?)(\/.*)/, '$1' + domain + '$3');
      // }
      return config.keycloakUrl;
    });
  }

  /**
   * Gets the keycloak client config value
   *
   * @return {Promise<string>} The keycloak client
   */
  getKeycloakClient () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.keycloakClient;
    });
  }

  /**
   * Gets the keycloak realm config value
   *
   * @return {Promise<string>} The keycloak default realm
   */
  getKeycloakDefaultRealm () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.keycloakDefaultRealm;
    });
  }

  /**
   * Gets the logging service config value
   *
   * @return {Promise<string>} The logging service base url
   */
  getLoggingService () {
    var self = this;
    return self.configPromise.then(function(config) {
        return config.loggingService;
    });
  }

  getBranding() {
    return DEFAULT_CONFIG.branding;
  }

  getPasswordMinimumLength() {
    return DEFAULT_CONFIG.passwordMinimumLength;
  }
}

ConfigService.getInstance = function() {
  if (ConfigService.instance instanceof ConfigService) { return ConfigService.instance;}
  return new ConfigService(getDefaultConfig());
};

/**
 *
 * @return {Promise} The promise that returns the config object
 */
function getDefaultConfig() {
  return Promise.resolve(DEFAULT_CONFIG);
}

export default ConfigService;
